export const isEventbriteEnabled = () => {
  try {
    return window.localStorage.getItem("badgeflow-eventbrite-enabled") === "true";
  } catch {
    // Unavailable or blocked storage leaves the feature disabled.
    return false;
  }
};

export const requireEventbriteEnabled = () => {
  if (!isEventbriteEnabled()) throw new Error("Eventbrite is not enabled in this browser.");
};
